import { render, staticRenderFns } from "./addBank.vue?vue&type=template&id=4fc18df8&scoped=true&"
import script from "./addBank.vue?vue&type=script&lang=js&"
export * from "./addBank.vue?vue&type=script&lang=js&"
import style0 from "./addBank.vue?vue&type=style&index=0&id=4fc18df8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc18df8",
  null
  
)

export default component.exports